import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPolicyPage, privacyHead } from "@/features/legal-documents";

export const Route = createFileRoute("/privacy")({
    component: PrivacyPolicyPage,
    head: privacyHead,
});
